import { useEffect } from 'react';
import { ConnectDragPreview } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

export function useEmptyDragPreview(preview: ConnectDragPreview): void {
  useEffect(() => {
    preview(getEmptyImage());
  }, [preview]);
}
